import 'bootstrap/js/src/modal'

$(window).on('load', function(){
  $('#recorded-classes-info-modal').modal('show');
});

$(document).on('change', '.label-check', function(e) {
  // to uncheck the same option in filter items in mobile/desktop view
  if(!$(this).children('input').prop('checked')){
    const id = $(this).children('input').prop('id')
    removeSelectItems(id);
    $('li.selected-filter-item').find('#' + id).hide();
  }
  videoSearch()
})

var timeout = null;
$('.video-search-text-box').on('keyup', function(e){
  clearTimeout(timeout);

  timeout = setTimeout(function() {
    videoSearch()
  }, 500);
});

function videoSearch() {
  $('#selected-filter-items').empty();
  let search_query = ($('.video-search-text-box').val()).trim()
  let checkboxes = $('.custom-checkbox:checkbox:checked')
  let video_tag_ids = []
  Array.from(checkboxes).forEach(element => {
    if (!video_tag_ids.includes(element.value)){
      video_tag_ids.push(element.value)
      addSelectItems(element.id, element.name)
    }
    // to check the same option in filter items in mobile/desktop view
    $('.custom-checkbox#' + element.id).prop('checked',true);
  });

  displayFilterCount();
  clearAllButton();

  $.ajax({
    url: '/videos/search',
    data: { search_tag: search_query, video_tag_id: video_tag_ids },
  });
}

$(function() {
  let urlParams = new URLSearchParams(window.location.search);
  let tag = urlParams.get('tag');
  let selector = `#category-id-${tag}`
  $(selector).prop('checked', true);
  if(tag){
    videoSearch()
  }
});

// Open Dropdown
$('.category-col').on('click', function(e){
  let category_filter = $(e.currentTarget).find('.category-filter')
  $('.category-filter').not(category_filter).hide();
  $(category_filter).toggle();
  $(this).toggleClass('active').siblings().removeClass('active');
})

// Close Dropdown
$(document).on('click', function(event) {
  if (!$(event.target).closest('.category-col').length || $(event.target) == $('.category-col')) {
    // Hide the menus.
    let category_filter = $(event.currentTarget).find('.category-filter')
    $(category_filter).hide();
    $('.category-col').removeClass('active');
  }
});

// Clear filter
$('.clear__category-btn').on('click', function(e){
  $('.custom-checkbox:checkbox:checked').prop('checked', false);
  $('#selected-filter-items').empty();
  videoSearch();
})

// Show/Hide clear all button
function clearAllButton() {
  let checkboxes = $('.custom-checkbox:checkbox:checked')
  if(checkboxes.length > 0){
    $(".library-category .clear__category-btn").show();
    $('.library-category.selected-filters').show();
    $('.library__category-outer .container .tab__content-outer').addClass('active');
  }
  else{
    $(".library-category .clear__category-btn").hide();
    $('.library-category.selected-filters').hide();
    $('.library__category-outer .container .tab__content-outer').removeClass('active');
  }
}

clearAllButton();

function addSelectItems(id, name) {
  let list = `<li class="selected-filter-item" id=${id}>` + name + '<span class="close-filter-item"></span></li>'
  $("#selected-filter-items").append(list);
}

function displayFilterCount() {
  const categoryCount = $('.category-selected .custom-checkbox:checkbox:checked').length/2;
  if(categoryCount > 0){
    $('.category-count').text(`(${categoryCount})`);
  } else{
    $('.category-count').text("");
  }

  const trainerCount = $('.trainer-selected .custom-checkbox:checkbox:checked').length/2;
  if(trainerCount > 0){
    $('.trainer-count').text(`(${trainerCount})`);
  } else{
    $('.trainer-count').text("");
  }
}

function removeSelectItems(id) {
  $('.custom-checkbox#' + id).prop('checked',false);
  displayFilterCount();
  videoSearch();
}

/* Open the filter drawer in mobile view */
$('.open-filter-drawer').on('click', function(){
  $("#filterDrawer").width("100%");
})
/* Close the filter drawer in mobile view */
$('.close-filter-drawer').on('click', function(){
  $("#filterDrawer").width("0");
})
/* Close individual selected filter items */
$('#selected-filter-items').on("click", '.close-filter-item', function () {
  $(this).parents('li').remove();
  removeSelectItems($(this).parent().prop('id'));
});
